/* eslint-disable no-console */
/** @ts-check */

(function () {
  "use strict";

  /**
   * @typedef {{ cookieDays?: number }} BVAffiliateTrackingConfig
   * @typedef {{ config?: BVAffiliateTrackingConfig }} BVAffiliateTracking
   * @typedef {Window & { BV_AFFILIATE_TRACKING?: BVAffiliateTracking }} WindowWithBV
   */

  /** @type {WindowWithBV} */
  var win = window;

  // -----------------------------
  // Config (default 15 days)
  // -----------------------------
  /** @type {number} */
  var COOKIE_DAYS =
    win.BV_AFFILIATE_TRACKING &&
    win.BV_AFFILIATE_TRACKING.config &&
    typeof win.BV_AFFILIATE_TRACKING.config.cookieDays === "number"
      ? win.BV_AFFILIATE_TRACKING.config.cookieDays
      : 15;

  /** @type {string} */
  var SOURCE = "impact";

  // -----------------------------
  // Helpers
  // -----------------------------

  /**
   * @param {string} name
   * @returns {string}
   */
  function getParam(name) {
    try {
      var params = new URLSearchParams(win.location.search);
      var val = params.get(name);
      return typeof val === "string" ? val : "";
    } catch (e) {
      return "";
    }
  }

  /**
   * @param {string} name
   * @param {string} value
   * @param {number} days
   * @returns {void}
   */
  function setCookie(name, value, days) {
    try {
      if (!value) return;

      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);

      win.document.cookie =
        encodeURIComponent(name) +
        "=" +
        encodeURIComponent(value) +
        ";expires=" +
        d.toUTCString() +
        ";path=/;SameSite=Lax";
    } catch (e) {
      // ignore
    }
  }

  /**
   * @param {string} name
   * @returns {string}
   */
  function getCookie(name) {
    try {
      var cookies = win.document.cookie || "";
      var re = new RegExp("(^| )" + encodeURIComponent(name) + "=([^;]+)");
      var match = cookies.match(re);

      if (!match || typeof match[2] !== "string") return "";
      return decodeURIComponent(match[2]);
    } catch (e) {
      return "";
    }
  }

  /**
   * @returns {boolean}
   */
  function shouldRunForImpact() {
    var src = (getParam("utm_source") || "").toLowerCase();
    return src === "impact";
  }

  /**
   * @param {Record<string, string>} attrs
   * @returns {Record<string, string>}
   */
  function cleanAttributes(attrs) {
    /** @type {Record<string, string>} */
    var cleaned = {};

    Object.keys(attrs).forEach(function (key) {
      var val = attrs[key];
      if (typeof val === "string" && val.trim() !== "") {
        cleaned[key] = val.trim();
      }
    });

    return cleaned;
  }

  /**
   * @param {Record<string, string>} attributes
   * @returns {void}
   */
  function updateCartAttributes(attributes) {
    try {
      if (!attributes || Object.keys(attributes).length === 0) return;

      /** @type {{ attributes: Record<string,string> }} */
      var payload = { attributes: attributes };

      void win.fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload),
      });
    } catch (e) {
      // ignore
    }
  }

  // -----------------------------
  // Start
  // -----------------------------
  if (!shouldRunForImpact()) return;

  // Based strictly on provided Impact sample URL:
  // Affiliate ID = irpid (3080690)
  // Click ID     = irclickid (Sfr3C5SRmxyc...)
  var affiliateId = getParam("irpid");
  var clickId = getParam("irclickid");

  // optional from sample URL
  var sharedId = getParam("sharedid");
  var irgwc = getParam("irgwc");
  var afsrc = getParam("afsrc");

  // Also keep standard UTM optional fields
  var utmCampaign = getParam("utm_campaign");
  var utmMedium = getParam("utm_medium");

  // Only set cookieDate if actual affiliate signal exists
  var cookieDate = affiliateId || clickId ? new Date().toISOString() : "";

  // Persist cookies only if signal exists
  if (affiliateId || clickId) {
    setCookie("impactAffiliateId", affiliateId, COOKIE_DAYS);
    setCookie("impactClickId", clickId, COOKIE_DAYS);
    setCookie("impactCookieDate", cookieDate, COOKIE_DAYS);
    setCookie("affiliateSource", SOURCE, COOKIE_DAYS);

    // optional
    setCookie("impactSharedId", sharedId, COOKIE_DAYS);
    setCookie("impactIrgwc", irgwc, COOKIE_DAYS);
    setCookie("impactAfsrc", afsrc, COOKIE_DAYS);
    setCookie("impactUtmCampaign", utmCampaign, COOKIE_DAYS);
    setCookie("impactUtmMedium", utmMedium, COOKIE_DAYS);
  }

  /** @type {Record<string, string>} */
  var rawAttributes = {
    // required
    impactAffiliateId: getCookie("impactAffiliateId"),
    impactClickId: getCookie("impactClickId"),
    impactCookieDate: getCookie("impactCookieDate"),
    affiliateSource: getCookie("affiliateSource") || SOURCE,

    // optional
    impactSharedId: getCookie("impactSharedId"),
    impactIrgwc: getCookie("impactIrgwc"),
    impactAfsrc: getCookie("impactAfsrc"),
    impactUtmCampaign: getCookie("impactUtmCampaign"),
    impactUtmMedium: getCookie("impactUtmMedium"),
  };

  var finalAttributes = cleanAttributes(rawAttributes);

  // Stop if nothing meaningful
  if (!finalAttributes.impactAffiliateId && !finalAttributes.impactClickId) return;

  updateCartAttributes(finalAttributes);

  console.log("[BV Impact] ✅ Initialized", {
    cookieDays: COOKIE_DAYS,
    attributes: finalAttributes,
  });
})();
